import { isLoaded } from 'react-redux-firebase'

export default function suspendUntilLoaded(...items) {
  if (items.some(item => !isLoaded(item))) {
    throw new Promise(resolve => {
      // resolve so this promise can be discarded
      setTimeout(resolve, 5000)
    })
  }
}
